import React, { useState, useRef } from "react";
import "./ContactUs.css";

const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxo7hzA3mEEr7nX7B3Et1A2plTdO1HRQE547n2SPuyo4HAxEZ--Rs8JRhNAcCVjTPCY/exec";

const ContactUs = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const timeoutRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleMouseEnter = () => {
    setIsHovered(true);
    clearTimeout(timeoutRef.current);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsHovered(false);
    }, 300);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    const name = formData.name.trim();
    const email = formData.email.trim();
    const message = formData.message.trim();

    if (!name || !email || !message) {
      setStatus("Please fill all fields.");
      return;
    }

    setLoading(true);
    setStatus("");

    try {
      // mode: "no-cors" hides the 302 redirect error from the browser
      await fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
        body: JSON.stringify({
          name,
          email,
          message,
        }),
      });

      // Since mode: "no-cors" makes the response opaque, 
      // we assume success if no network error was thrown.
      setStatus("Request sent. Please check your email for confirmation.");
      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Submission error:", error);
      setStatus("Unable to send request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`contact-button-container ${isHovered ? "hovered" : ""}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button type="button" className="contact-button">
        Contact Us
      </button>

      <div className="contact-info">
        <form onSubmit={handleSubmit}>
          <h2 className="font-medium">Contact Us</h2>

          <p>
            Get the most value from your enterprise assets with
            iAssetMax™ Application Management.
          </p>

          <div>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <textarea
              className="InText"
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="4"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="py-2 hover:bg-[#047fccda] bg-[#047FCC] text-[#fff]"
          >
            {loading ? "Sending..." : "Send Message"}
          </button>

          {status && <p role="status">{status}</p>}
        </form>
      </div>
    </div>
  );
};

export default ContactUs;